import { Pipe, PipeTransform } from '@angular/core';

import { COUNTRY_CODES } from '@core/constants';

/*
 * Convert a country code to a country name
 * Takes a displayCode argument that defaults to false.
 * If no mapping is found, the country code is returned
 * Usage:
 *   value | countryName:displayCode
 * Example:
 *   {{ 'FR' | countryName }}
 *   formats to: 'France'
 *   {{ '' | countryName }}
 *   formats to: ''
 *   {{ '' | countryName: "Unknown" }}
 *   formats to: 'Unknown'
*/

@Pipe({
  name: 'countryName',
  standalone: true,
})
export class CountryNamePipe implements PipeTransform {

  public transform(value: any, unknownText?: string): string {
    let name: string = '';
    if (typeof value === 'string') {
      value = value.toUpperCase();
      name = COUNTRY_CODES.ALL[value];
    }
    return name || unknownText || value;
  }

}
